/*
 * Triggers GA custom events as per
 * OMG supplied specs
 * 
 * @author BarrelNY
 *
 */
var constant = {
	team: ['External Link','Click'],
	tel: ['Click to Call','Click'],
	mailto: ['Click to Email','Click'],
	register: ['Register/Contact','Click'],
	floorplan: ['Floorplan','Download']
} 

var Ga = {
	init:function(){
		this.events();
	},
	
	events:function(){
		$('body')
			.on('click','[data-ga]',this.labelize.bind(this));
	},
	
	/*
	 * Since the label is dynamic, we get it via js 
	 * before triggering the GA event. This method
	 * also check classes to prevent default or 
	 * change the document location
	 *
	 * @param	obj	event obj
	 * @returns	void
	 */
	labelize:function(e){
		var 
			$el = $(e.currentTarget),
			relocate = $el.hasClass('ga-relocate'),
			prevent = $el.hasClass('ga-nodefault');
			
		if (prevent) e.preventDefault();
		
		var 
			action = $el.attr('data-ga'),
			label;
			
		switch (action){
			case 'team':
				label = $el.siblings('h2').text();
			break;
			case 'tel':
			case 'mailto':
			case 'register':
				label = $el.parents('footer').length ? 'Footer' : 'Contact Page';
			break;
			case 'floorplan':
				label = 'Residence' +
				$el
					.parents('tr.unit')
					.find('.unit-title')
					.html()
					.replace(/(<h4.[^>]*>.*<\/h4>)/gi,'')
					.replace(/\s/gi,'');
			break;
		}
		
		this.send(label,action);
		
		if (relocate){
			setTimeout(function(){
				var href = $el.attr('href');
				if (href) window.location = href;
			},300);
		}
	},
	
	/*
	 * Use the Google Analytics API to send
	 * custom event
	 *
	 * @param	string	the label to send to GA
	 * @param	action	the string stated in the el's data-ga attr
	 * @returns	void
	 */
	send: function(label,action){
		if (!ga) return;
		ga('send','event',constant[action][0],constant[action][1],label);
	}
}

Ga.init();